<div class="c-wizard" [ngClass]="{ 'c-wizard--typeA': variation }">
  <span class="c-wizard_stepBox"
        *ngFor="let step of stepsList; let ind = index;"
        [ngClass]="{ 's-stepActive': ((ind+1) === activeStep) }">{{ variation ? '' : step }}</span>
</div>
